<template>
  <div class="card" v-if="isShow">
    <div class="card-title">4. 评分类型配置（后台调用 + 分值判断）</div>
    
    <div class="row">
      <div class="label">头部标题</div>
      <input v-model="value.headerTitle" style="width:280px" :disabled="vimSave" />
    </div>
    <div class="row">
      <div class="label">头部背景色</div>
      <input v-model="value.headerBg" style="width:120px" disabled />
      <input type="color" v-model="value.headerBg" class="native-color-picker"  :disabled="vimSave"/>
      <!-- <div class="color-preview" :style="{background:value.headerBg}"></div> -->
    </div>
    <div class="row">
      <div class="label">页面背景色</div>
      <input v-model="value.pageBg" style="width:120px" disabled />
      <input type="color" v-model="value.pageBg" class="native-color-picker" :disabled="vimSave"/>
      <!-- <div class="color-preview" :style="{background:value.pageBg}"></div> -->
    </div>

    <div class="row">
      <div class="label">上传图标</div>
      <img v-if="isImage(value.cameraIcon)" :src="value.cameraIcon" class="icon-preview">
      <span v-else class="emoji-preview">{{ value.cameraIcon}}</span>
      <label class="upload-btn">上传<input type="file" hidden accept="image/*" :disabled="vimSave" @change="select('cameraIcon', $event)" /></label>
      <button @click="reset('cameraIcon')" class="reset-btn" :disabled="vimSave">重置</button>
    </div>

    <div class="score-group" style="margin-top:16px;">
      <div class="card-title" style="margin-bottom:10px;">评分项配置</div>

      <el-table
        :data="value.scoreItems"
        border
        size="medium"
        style="width:100%;"
      >
        <!-- 【新增】图标列，宽度和你的UI适配 -->
        <el-table-column label="图标" width="220" align="center">
          <template #default="scope">
            <div style="display:flex; align-items:center; justify-content:center; gap:4px;">
              <!-- 图标显示：图片/Emoji -->
              <img 
                v-if="isImage(scope.row.icon)" 
                :src="scope.row.finalIcon" 
                class="score-icon"
              >
              <span 
                v-else 
                class="score-emoji"
              >{{ scope.row.icon }}</span>

              <!-- 上传+重置按钮，用小图标样式，不占空间 -->
              <label class="mini-upload-btn" title="上传图标">
                📎
                <input 
                  type="file" 
                  hidden 
                  accept="image/*"
				  :disabled="vimSave"
                  @change="selectItemIcon(scope.$index, $event)"
                />
              </label>
              <button 
                @click="resetItemIcon(scope.$index)"
                class="mini-reset-btn"
                title="重置图标"
				:disabled="vimSave"
              >
                ↩️
              </button>
            </div>
          </template>
        </el-table-column>

        <!-- 评分名称 -->
        <el-table-column label="评分名称" width="130">
          <template #default="scope">
            <input
              v-model="scope.row.name"
              placeholder="请输入名称"
              class="input-field"
              style="width:100%;"
			  :disabled="vimSave"
            />
          </template>
        </el-table-column>

        <!-- 调用模型 -->
        <el-table-column label="调用模型" width="180">
         <template #default="scope">
           <el-select
             v-model="scope.row.modelId"
             filterable
             clearable
             placeholder="选择模型"
             style="width:100%;"
             :disabled="vimSave"
			@change="val => forModelId(val, scope.row)"
           >
             <el-option
               v-for="k in modelList"
               :key="k.id"
               :label="k.name"
               :value="k.id"
             />
           </el-select>
         </template>
        </el-table-column>

        <!-- 调用密钥 -->
        <el-table-column label="调用密钥" width="180">
          <template #default="scope">
            <el-select
              v-model="scope.row.keyId"
              filterable
              clearable
              placeholder="选择密钥"
              style="width:100%;"
			  :disabled="vimSave||!scope.row.modelId"
            >
              <el-option
                v-for="k in scope.row.keyList|| []"
                :key="k.id"
                :label="k.keyName"
                :value="k.id"
              />
            </el-select>
          </template>
        </el-table-column>

        <!-- 优秀分数线 -->
        <el-table-column label="优秀分数线" width="120">
          <template #default="scope">
            <input
              v-model.number="scope.row.goodScore"
              placeholder="分数线"
              class="input-field"
              style="width:100%;"
			  :disabled="vimSave"
            />
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="80">
          <template #default="scope">
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="delItem(scope.$index)"
              v-if="scope.row && scope.$index == value.scoreItems.length-1"
              :disabled="vimSave"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <button @click="addItem" class="upload-btn" style="margin-top:8px;" :disabled="vimSave">
        + 添加评分项
      </button>
    </div>
  </div>
</template>

<script>
import { fileToBase64 } from '@/js/img.js'
import { forUpload } from "@/js/calssComponets.js"

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        headerTitle: '作品评价',
        headerBg: '#e3f2fd',
        pageBg: '#ffffff',
        cameraIcon: '📷',
        scoreItems: [
          { key: 1, name: "设计图", icon: "🖼️", modelId: "",keyList:[], keyId: "", goodScore: 90 },
          { key: 2, name: "方案", icon: "📝", modelId: "", keyList:[],keyId: "", goodScore: 85 },
        ]
      })
    },
    modelList: { type: Array, default: () => [] },
    vimSave: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      iconUrlMap: {},
      upload: {},
      keyList: [],
      // 标记：只加载一次 OSS
      resolved: false,
	  isShow:false,
    }
  },
  created() {
    this.upload = forUpload()
    // 只在创建时加载一次，不监听！
    this.resolveAllIcons()
  },
  methods: {
    // ============= 核心：只执行一次 OSS 转址 =============
    async resolveAllIcons() {
      if (this.resolved) return;
      this.resolved = true;
    
      if (!this.value) return;
      console.log('this.value.cameraIcon', this.value.cameraIcon)
    
      // 处理顶部相机图标
      if (this.value.cameraIcon && this.value.cameraIcon.startsWith('http')) {
        try {
          let realUrl = await this.$oss.getUrl(this.value.cameraIcon);
          const newValue = { ...this.value };
          newValue.cameraIcon = realUrl;
          this.$emit('input', newValue);
        } catch (err) {}
      }
    
      // 1. 先过滤掉数组里的 null / undefined 项（关键）
      const itemList = (this.value.scoreItems || []).filter(item => !!item);
	  
      for (let item of itemList) {
        // 2. 单项再次判空，双重防护
        if (!item) continue;
			
        // 加载密钥列表
        if (item.keyId) {
          try {
            let keyarr = await this.API.get(this.API.admin.getModelKeyArr + item.keyId)
			
            item.keyList = [keyarr.data.data] || []
          } catch (err) {
            item.keyList = []
          }
        }
    
        // 处理图标转址
        if (item.icon && item.icon.startsWith('http')) {
          try {
            let realUrl = await this.$oss.getUrl(item.icon);
            item.finalIcon = realUrl;
          } catch (err) {
            item.finalIcon = item.icon;
          }
        } else {
          item.finalIcon = item.icon;
        }
      }
	  this.isShow=true
    },

    // ============= 工具方法 =============
    isImage(val) {
      return typeof val === 'string' && (val.startsWith('data:') || val.startsWith('http'))
    },

    // ============= 顶部图标上传 =============
    async select(key, e) {
      const file = e.target.files[0]
      if (!file) return
      const base64 = await fileToBase64(file)
      const newValue = { ...this.value }
      newValue[key] = base64
      this.$emit('input', newValue)
      e.target.value = ''
    },

    // ============= 评分项图标上传（立即渲染） =============
    async selectItemIcon(index, e) {
      const file = e.target.files[0]
      if (!file) return
      const base64 = await fileToBase64(file)

      // 深拷贝，强制触发Vue更新
      const newValue = JSON.parse(JSON.stringify(this.value))
      newValue.scoreItems[index].icon = base64
      newValue.scoreItems[index].finalIcon = base64 // 立即显示

      this.$emit('input', newValue)
      e.target.value = ''
    },

    // ============= 重置图标 =============
    reset(key) {
      const newValue = { ...this.value };
      if (key === 'cameraIcon') {
        newValue.cameraIcon = this.upload.cameraIcon || '📷';
      } else {
        newValue[key] = '';
      }
      this.$emit('input', newValue);
    },

    resetItemIcon(index) {
      const newValue = { ...this.value }
      newValue.scoreItems = newValue.scoreItems.map((item, i) => {
        if (i === index) {
          return { ...item, icon: '⭐', finalIcon: '⭐' }
        }
        return item
      })
      this.$emit('input', newValue)
    },

    // ============= 增删评分项 =============
    addItem() {
      const maxKey = this.value.scoreItems.length > 0
        ? Math.max(...this.value.scoreItems.map(i => i.key || 0))
        : 0
      const newItem = {
        key: maxKey + 1,
        name: '',
        icon: '⭐',
        finalIcon: '⭐',
        modelId: '',
        keyId: '',
        goodScore: 80,
        keyList: []
      }
      const newValue = { ...this.value }
      newValue.scoreItems = [...newValue.scoreItems, newItem]
      this.$emit('input', newValue)
    },

    delItem(idx) {
      const newValue = { ...this.value }
      newValue.scoreItems = newValue.scoreItems.filter((_, i) => i !== idx)
      this.$emit('input', newValue)
    },

    // ============= 模型/密钥 =============
    async forModelId(val, row) {
		row.keyId=''
      try {
        let aiType = this.modelList.find(v => v.id == val).aiTypeCode || ''
        const res = await this.API.get(this.API.admin.getModelKeySimple, {
          pageNum: 1,
          pageSize: 100,
          providerCode: aiType,
          modelTypeId: null
        })
		
        row.keyList = res.data.data || []
      } catch (e) {
        row.keyList = []
      }
    }
  }
}
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px #00000010;
}
.card-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}
.row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.label {
  width: 110px;
  font-size: 14px;
  color: #666;
}
input {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}
.color-preview {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.icon-preview {
  width: 28px;
  height: 28px;
  object-fit: contain;
  border-radius: 4px;
}
.emoji-preview {
  font-size: 20px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-btn {
  padding: 4px 10px;
  background: #e8f3ff;
  color: #2b85e4;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #b3d8ff;
}
.reset-btn {
  padding: 4px 8px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

/* 评分项图标样式，和你的UI适配 */
.score-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 3px;
}
.score-emoji {
  font-size: 18px;
  line-height: 1;
}
.mini-upload-btn,
.mini-reset-btn {
  font-size: 12px;
  padding: 2px 4px;
  border: none;
  background: transparent;
  cursor: pointer;
}
.mini-upload-btn:hover,
.mini-reset-btn:hover {
  background: #f0f0f0;
  border-radius: 3px;
}

.input-field {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-sizing: border-box;
}
.select-field { width: 100%; }

:deep(.el-select__wrapper) {
  height: 32px;
  display: flex;
  align-items: center;
}
	.native-color-picker {
		width: 30px;
		height: 30px;
		border: none;
		background: none;
		cursor: pointer;
		padding: 0;
	}

	.native-color-picker::-webkit-color-swatch-wrapper {
		padding: 0;
	}

	.native-color-picker::-webkit-color-swatch {
		border-radius: 4px;
		border: 1px solid #ddd;
	}
</style>